import {
  getUsersService,
  getRoleUserCERTService,
  getRolePermissionsCERTService,
  getRoleUserSERVService,
  getRolePermissionsSERVService,
  getRoleUserADMService,
  getRolePermissionsADMService,
  getUserProvider
} from "../services/yclickMasterService";

// ----- Services ----- //
export const getUsers = (value) =>
  new Promise((resolve, reject) => {
    getUsersService(value)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

export const getRoleUser = () =>
  new Promise((resolve, reject) => {
    Promise.all([getRoleUserCERTService(), getRoleUserSERVService(), getRoleUserADMService()])
      .then(([resCert, resServ, resAdm]) => {
        // this filtering logic is used to remove deprecated roles
        // it must be updated before deploying
        const resCertFiltered = resCert.data.filter((rol) =>
          rol.nombre.includes("Yclick!")
        );
        const resServFiltered = resServ.data.filter((rol) =>
          rol.nombre.includes("Yclick!")
        );
        const resAdmFiltered = resAdm.data.filter((rol) =>
        rol.nombre.includes("Yclick!")
      );

        const rolesJoined = [...resCertFiltered, ...resServFiltered, ...resAdmFiltered];
        const rolesMap = rolesJoined.map((item) => [item.id, item]);
        const rolesMapArr = new Map(rolesMap);

        resolve([...rolesMapArr.values()]);
      })
      .catch((err) => reject(err));
  });

export const getRolePermissions = () =>
  new Promise((resolve, reject) => {
    Promise.all([
      getRolePermissionsCERTService(),
      getRolePermissionsSERVService(),
      getRolePermissionsADMService(),
    ])
      .then(([resCert, resServ, resAdm]) => resolve([...resCert.data, ...resServ.data, ...resAdm.data]))
      .catch((err) => reject(err));
  });

export const getCurrentProvider = async() =>{
  const currentProviderResponse = await getUserProvider();
  return currentProviderResponse.data.nombre;
}